import React from 'react';

import CtaArrowRight from '@digital-hig/icon/icons/cta-arrow-right';
import Forward from '@digital-hig/icon/icons/forward';
import SvgIcon from '@digital-hig/mui/SvgIcon';
import sanitizeHtml from 'sanitize-html';

interface HeadingWithLinkProps {
  className?: string;
  title: string;
  subTitle: string;
  textColor?: 'dark' | 'light';
  titleSize?: 'small' | 'medium' | 'large';
  linkStyle?: 'arrow' | 'cta';
  linkAnchor?: string;
  handleClick?: () => void;
}

const cssClassName = 'heading';

function HeadingWithLink({
  className = '',
  title,
  subTitle,
  textColor = 'dark',
  titleSize = 'medium',
  linkStyle = 'arrow',
  linkAnchor,
  handleClick = () => {},
}: HeadingWithLinkProps) {
  return (
    <div
      className={`
        ${className}
        ${cssClassName}
        container
        au-py-[5px]
        ${textColor === 'dark' && 'au-text-black'}
        ${textColor === 'light' && 'au-text-white'}
      `}
      id={linkAnchor}
    >
      {title && (
        <h2
          className={`${cssClassName}__title au-mb-[5px] has-${titleSize}-font-size`}
        >
          {title}
        </h2>
      )}
      {subTitle && (
        <button
          type="button"
          className={`${cssClassName}__sub au-flex au-mb-[5px] au-bg-transparent au-border-0 au-p-0 au-cursor-pointer`}
          onClick={handleClick}
        >
          {linkStyle === 'arrow' ? (
            <SvgIcon fontSize="medium">
              <Forward color={textColor === 'light' ? 'white' : 'black'} />
            </SvgIcon>
          ) : (
            <SvgIcon fontSize="medium">
              <CtaArrowRight
                color={textColor === 'light' ? 'white' : 'black'}
              />
            </SvgIcon>
          )}
          <div
            className={`${cssClassName}__subTitle au-pl-[9px] au-text-[14px] au-font-light`}
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(subTitle) }}
          />
        </button>
      )}
    </div>
  );
}

HeadingWithLink.attributes = {
  title: {
    type: 'string',
    default: 'Heading with link title',
  },
  subTitle: {
    type: 'string',
    default: 'this is a subtitle',
  },
  textColor: {
    type: 'string',
    default: 'dark',
    options: ['dark', 'light'],
  },
  titleSize: {
    type: 'string',
    default: 'medium',
    options: ['small', 'medium', 'large'],
  },
  linkStyle: {
    type: 'string',
    default: 'arrow',
    options: ['arrow', 'cta'],
  },
  linkAnchor: {
    type: 'string',
    default: '',
  },
  className: {
    type: 'string',
    default: '',
  },
};

export default HeadingWithLink;
